<!--日生产计划零件-->
<template>

  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="供应商">
              <!-- <global-select
                @change="handleVersionChange"
                :value.sync="queryParams.vendorCode"
                selectType="select"
                requestApi="/scp/scpProductionScheduling/listSupplier"
                :selectItem="{ value: 'realValue', label: 'label' }"
              /> -->
              <global-select
                v-decorator="['vendorCode']"
                :value.sync="queryParams.vendorCode"
                selectType="selectSearch"
                searchParam="supplier"
                :allowClear="organizationCodeOrigin==='A001'"
                :default-active-first-option="organizationCodeOrigin!=='A001'"
                :dropdown-match-select-width="false"
                requestApi="/scp/scpProductionScheduling/getSupplierList"
                :selectItem="{ value: 'supplierCode', label: 'supplierName' }"
                :setParams="{ organizationCode: organizationCodeOrigin }" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="交货时间">
              <a-range-picker
                :placeholder="['开始日期', '结束日期']"
                valueFormat="YYYY-MM-DD"
                format="YYYY-MM-DD"
                v-model="queryParams.deliveryDateTem"
                @change="onChangeDeliveryDate" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="下单计划时间" :labelCol="{ style: { width: '110px' } }">
              <a-range-picker
                :placeholder="['开始日期', '结束日期']"
                valueFormat="YYYY-MM-DD"
                format="YYYY-MM-DD"
                v-model="queryParams.issuedTimeTem"
                @change="onChangeIssuedTime" />
            </a-form-item>
          </a-col>
          <a-col :md="6" v-if="advanced" :sm="24">
            <a-form-item label="计划单号">
              <a-input v-model="queryParams.orderNumber" />
              <!-- <global-select
                :value.sync="queryParams.orderNumber"
                selectType="select"
                :setParams="{type:1}"
                requestApi="/scp/scpProductionScheduling/ljComboBox"
                :selectItem="{ value: 'realValue', label: 'label' }"></global-select> -->
            </a-form-item>
          </a-col>
          <a-col :md="6" v-if="advanced" :sm="24">
            <a-form-item label="零部件-物料编码">
              <a-input v-model="queryParams.itemCode" />
              <!-- <global-select
                :value.sync="queryParams.itemCode"
                selectType="select"
                :setParams="{type:2}"
                requestApi="/scp/scpProductionScheduling/ljComboBox"
                :selectItem="{ value: 'realValue', label: 'label' }"></global-select> -->
            </a-form-item>
          </a-col>
          <a-col :md="6" v-if="advanced" :sm="24">
            <a-form-item label="零部件-物料名称">
              <a-input v-model="queryParams.itemName" />
              <!-- <global-select
                :value.sync="queryParams.itemName"
                selectType="select"
                :setParams="{type:3}"
                requestApi="/scp/scpProductionScheduling/ljComboBox"
                :selectItem="{ value: 'realValue', label: 'label' }"></global-select> -->
            </a-form-item>
          </a-col>
          <a-col :md="6" v-if="advanced" :sm="24">
            <a-form-item label="产线标识">
              <a-select v-model="queryParams.lineFlag" allowClear>
                <a-select-option v-for="(item) in yesOrNoOptions" :key="item.value">{{ item.label }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" v-if="advanced" :sm="24">
            <a-form-item label="排产标识">
              <a-select v-model="queryParams.planFlag" allowClear>
                <a-select-option v-for="(item) in yesOrNoOptions" :key="item.value">{{ item.label }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" v-if="advanced" :sm="24">
            <a-form-item label="签价单号">
              <a-input v-model="queryParams.alternativeMaterialList" />
            </a-form-item>
          </a-col>
          <a-col :md="6" v-if="advanced" :sm="24">
            <a-form-item label="交易单号">
              <a-input v-model="queryParams.transactionOrderNo" />
            </a-form-item>
          </a-col>
          <a-col :md="6" v-if="advanced" :sm="24">
            <a-form-item label="订单行ID">
              <a-input v-model="queryParams.orderLineId" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper display-flex" slot="btn">
      <!-- <a-button @click="handleExport" >成品</a-button> -->
      <div class="flex1"></div>
      <a-button @click="importTemplate" type="primary">导入模版</a-button>
      <a-button @click="importExcelHandleOpen" type="primary">导入</a-button>
      <a-button @click="handleExport" type="primary">导出</a-button>
      <a-button @click="handleGoSchedulingWorkbench" type="primary">排产工作台</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1300 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.PARTS_PRODUCT_LIST, // 表格方案配置唯一值
              }"
        >
          <template slot="planFlag" slot-scope="{ record }">
            <span>{{ record.planFlag }}</span>
          </template>
          <template slot="deliveryDate" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="issuedTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="updateTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="createTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="status" slot-scope="{ record }">
            <a-switch :disabled="!isEdit || currentId !== record.id" :checked="record.status === 'Y'" @change="statusOnChange(record)" />
          </template>
          <template slot="vendorCode" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.orderNo">{{ text }}</span>
            <global-select
              v-if="isEdit && currentId === record.orderNo"
              :value.sync="record.vendorCode"
              size="small"
              selectType="selectAssembleSearch"
              :allow-clear="false"
              requestApi="/scp/scpProductionScheduling/skuSupplierBox"
              :selectItem="{ value: 'realValue', label: 'label' }"
              :setParams="{ itemId: record.itemId }"
              sourseField="res"
              :dropdown-match-select-width="false"
              @change="(val, selectList) => handleVendorCodeSelectChange(val, selectList, record)"
            />
          </template>
          <!-- 操作 -->
          <span slot="operation" slot-scope="{ record }">
            <a v-if="(record.planFlag === 'N') && (!isEdit || currentId !== record.orderNo)" @click="handleEdit(record)" v-hasPermi="['mdm:mdmUomConversions:edit']">编辑</a>
            <a v-if="isEdit && currentId === record.orderNo" @click="handleSave(record)">保存</a>
            <a v-if="isEdit && currentId === record.orderNo" @click="handleCancel(record)" class="ml10">取消</a>
          </span>
        </ls-api-table>
        <!-- 上传文件 -->
        <a-modal
          :title="upload.title"
          :visible="excelVisible"
          @ok="importExcelHandleCancel"
          @cancel="importExcelHandleCancel"
        >
          <a-upload-dragger
            name="file"
            accept=".xlsx, .xls"
            :multiple="true"
            :headers="upload.headers"
            :action="upload.url + '?updateSupport=' + upload.updateSupport"
            @change="importExcelHandleChange"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">
              请将文件拖拽到此处上传
            </p>
            <p class="ant-upload-hint">
              支持单个或批量上传，也可以点击后选择文件上传
            </p>
          </a-upload-dragger>
        </a-modal>
      </div>

    </template>
  </ls-table-layout>
</template>

  <script>
  import { apiLjProductSearchList, apiScpProductionSchedulingLjProductUpdate } from '@/api/scp/dailyProductionPlan/dailyProductionPlan'
  import { generateLsTableResData } from '@/utils/util.js';
  import Cookies from 'js-cookie';
  import { mapState } from 'vuex'
  export default {
    name: 'PartsProduct',
    data () {
      const token = process.env.NODE_ENV === "development" ? localStorage.getItem('token') : Cookies.get('Admin-Token')
    const Authorization = token ? 'Bearer ' + token : undefined;
      return {
      mode: ['month', 'month'],
      // 导入excel
      excelVisible: false,
      // 用户导入参数
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: '导入Excel',
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: { Authorization: Authorization },
        // 上传的地址
        url: process.env.VUE_APP_API_BASE_URL + '/scp/scpProductionScheduling/ljProductImport'
      },
        // 表格配置
        tableProps: {
          requestApi: generateLsTableResData(apiLjProductSearchList, true),
          pageCurrent: true
        },
        isEdit: false,
        currentId: "",
        // 控制搜索展开
        advanced: true,
        // 查询参数
        queryParams: {
          vendorCode: undefined, // 供应商
          deliveryDateTem: undefined, // 交货时间临时
          deliveryDate1: undefined, // 交货时间起
          deliveryDate2: undefined, // 交货时间结束
          issuedTimeTem: undefined, // 计划单下达时间
          issuedTime1: undefined, // 计划单下达时间1
          issuedTime2: undefined, // 计划单下达时间2
          orderNumber: undefined, // 计划单号
          itemCode: undefined, // 成品编号
          alternativeMaterialList: undefined, // 签价单号
          itemName: undefined, // 物料名称
          transactionOrderNo: undefined, // 交易单号
          orderLineId: undefined // 订单行ID
        },
        // 表格多选
        selectedRowKeys: [],
        selectedRows: [],
        // 状态快码
        statusOptions: [
          {
            dictLabel: "有效",
            dictValue: "Y"
          },
          {
            dictLabel: "无效",
            dictValue: "N"
          }
        ],
        baseUomFlagOptions: [
          {
            dictLabel: "是",
            dictValue: "Y"
          },
          {
            dictLabel: "否",
            dictValue: "N"
          }
        ],
        // 表格字段
        columns: [
         {
            title: '计划单号',
            dataIndex: 'parentOrderNo',
            align: 'center',
           stickyFixed: 'left',
            ellipsis: true,
            width: 250
          },
          {
            title: '交货时间',
            scopedSlots: { customRender: 'deliveryDate' },
            dataIndex: 'deliveryDate',
            align: 'center',
            width: 160
          },
          {
            title: '生产时间',
            scopedSlots: { customRender: 'deliveryDate' },
            dataIndex: 'produceDate',
            align: 'center',
            width: 160
          },
          { title: '采购方编码', dataIndex: 'buyerCode', width: 120, align: 'center' },
          { title: '采购方简称', dataIndex: 'buyerAbbreviation', width: 120, align: 'center' },
          {
            title: '供应商',
            dataIndex: 'vendorCode',
            scopedSlots: { customRender: 'vendorCode' },
            width: 120,
            ellipsis: true,
            align: 'center'
          },
          {
            title: '供应商简称',
            dataIndex: 'supplierName',
            width: 120,
            ellipsis: true,
            align: 'center'
          },
          {
            title: '库存组织',
            dataIndex: 'orgName',
            width: 120,
            ellipsis: true,
            align: 'center'
          },
          {
            title: '零部件-物料编码',
            dataIndex: 'itemCode',
            ellipsis: true,
            width: 200,
            scopedSlots: { customRender: 'itemCode' },
            align: 'center'
          },
          { title: '计划来源', dataIndex: 'planSourceName', width: 140, align: 'center' },
          {
            title: '排产标识',
            dataIndex: 'planFlag',
            scopedSlots: { customRender: 'planFlag' },
            width: 150,
            align: 'center'
          },
          {
            title: '零部件-物料名称',
            width: 180,
            dataIndex: 'itemName',
            scopedSlots: { customRender: 'itemName' },
            ellipsis: true,
            align: 'center'
          },
          {
            title: '零部件-规格描述',
            width: 220,
            dataIndex: 'description',
            ellipsis: true,
            align: 'center'
          },
          {
            title: '单位',
            dataIndex: 'primaryUom',
            scopedSlots: { customRender: 'primaryUom' },
            width: 150,
            align: 'center'
          },
          {
            title: '需求数量',
            width: 120,
            dataIndex: 'orderQuantity',
            ellipsis: true,
            align: 'center'
          },
          {
            title: '计划单下达日期',
            dataIndex: 'issuedTime',
            scopedSlots: { customRender: 'issuedTime' },
            width: 150,
            align: 'center'
          },
          { title: '签价单号', dataIndex: 'alternativeMaterialList', width: 140, align: 'center' },
          { title: '交易单号', dataIndex: 'transactionOrderNo', width: 140, align: 'center' },
          { title: '订单行ID', dataIndex: 'orderLineId', width: 140, align: 'center' },
          {
            title: '产线标识',
            dataIndex: 'lineFlag',
            width: 100,
            align: 'center'
          },
          {
            title: '备注',
            dataIndex: 'remarks',
            scopedSlots: { customRender: 'remarks' },
            width: 150,
            align: 'center'
          },
          {
            title: '操作',
            width: 100,
            dataIndex: 'operation',
            scopedSlots: { customRender: 'operation' },
            stickyFixed: 'right'
          }
        ],
        uomClassOptions: [],
        unitOfMeasureList: [],
        unitOfMeasureListNew: [],
        yesOrNoOptions: [
          { label: '是', value: 'Y' },
          { label: '否', value: 'N' }
        ]
      }
    },
    computed: {
      ...mapState({
        organizationCodeOrigin: (state) => state.user.organizationCode
      })
    },
    created () {
      const lookupQueryParams = {
        lookupType: 'MDM_UOM_CLASSES',
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        this.uomClassOptions = response.rows
      })
    },
    mounted () {
      setTimeout(() => {
        this.onSearch()
      }, 1000)
    },
    methods: {
      tableChange (pagination) {

      },
      onChangeDeliveryDate (value, mode) {
        const yearMonth1 = value[0]
      const yearMonth2 = value[1]
      this.queryParams.deliveryDate1 = yearMonth1
      this.queryParams.deliveryDate2 = yearMonth2
      this.queryParams.deliveryDateTem = value
      },
      onChangeIssuedTime (value, mode) {
        const yearMonth1 = value[0]
      const yearMonth2 = value[1]
      this.queryParams.issuedTime1 = yearMonth1
      this.queryParams.issuedTime2 = yearMonth2
      this.queryParams.issuedTimeTem = value
      },
          /** 导入excel */
    importExcelHandleChange (info) {
      const status = info.file.status
      if (status !== 'uploading') {
      }
      if (status === 'done') {
        this.$message.success(`${info.file.name}: ${info.file.response.msg}`)
      } else if (status === 'error') {
        this.$message.error(`${info.file.name}: ${info.file.response.msg}`)
      }
    },
    /** 导入excel窗体关闭 */
    importExcelHandleCancel (e) {
      this.excelVisible = false
      // 关闭后刷新列表
      this.handleQuery()
    },
    /** 导入excel窗体开启 */
    importExcelHandleOpen (e) {
      this.excelVisible = true
    },
    /** 下载模板操作 */
    importTemplate () {
      this.download('scp/scpProductionScheduling/ljTemplate', {
        ...this.queryParams
      }, `日生产计划零件_${new Date().getTime()}.xlsx`)
    },
      blur (record) {
        if (!record.conversionRate || Number(record.conversionRate) <= 0) {
          this.$message.warning('折换不能为空且需大于0')
        } else {
          record.conversionRateInverse = this.$countBackwards(Number(record.conversionRate))
        }
      },
      statusOnChange (record) {
        record.status = record.status === 'Y' ? 'N' : 'Y'
      },
      // 导入导出excel
      /** 导出按钮操作 */
      handleExport () {
       const myPagination = this.$refs.dataTable.myPagination
        this.download('scp/scpProductionScheduling/LjProductExport', {
          ...this.queryParams, ...myPagination, pageNum: myPagination.current
        }, `日生产计划(零部件)_${new Date().getTime()}.xlsx`)
      },
      // 编辑
      handleEdit (record) {
        if (this.currentId && record.orderNo !== this.currentId && this.isEdit) {
          this.$message.warning('请保存上次编辑的数据')
          return;
        }
        this.isEdit = true;
        this.currentId = record.orderNo;
      },
      // 编辑-保存
      handleSave (record) {
        apiScpProductionSchedulingLjProductUpdate(record).then(response => {
          if (response.code === 200) {
            this.$message.success('保存成功')
            this.onSearch()
            this.isEdit = false;
          } else {
            this.$message.error(response.msg)
          }
        })
      },
      // 取消
      handleCancel (record) {
        this.isEdit = false
        this.onSearch()
      },
      // 新增/修改框事件
      handleOk () {
        this.onSearch()
      },
      // 表单搜索
      onSearch () {
        this.isEdit = false
        this.$refs.dataTable.searchParams = this.queryParams;
        this.$refs.dataTable.getData();
      },
      /** 重置按钮操作 */
      resetQuery () {
        this.queryParams = {
          vendorCode: this.queryParams.vendorCode, // 供应商(林氏产业园清空，其他情况不清空)
          deliveryDateTem: undefined, // 交货时间临时
          deliveryDate1: undefined, // 交货时间起
          deliveryDate2: undefined, // 交货时间结束
          issuedTimeTem: undefined, // 计划单下达时间
          issuedTime1: undefined, // 计划单下达时间1
          issuedTime2: undefined, // 计划单下达时间2
          orderNumber: undefined, // 计划单号
          itemCode: undefined, // 成品编号
          itemName: undefined // 物料名称
        }
        if(this.organizationCodeOrigin === 'A001') {
          this.queryParams.vendorCode = undefined
        }
        this.onSearch()
      },
      // 搜索框展开、收起
      toggleAdvanced () {
        this.advanced = !this.advanced
      },
      handleGoSchedulingWorkbench () {
        this.$router.push({ path: '/schedulingWorkbench' })
      },
      handleVendorCodeSelectChange (val, selectList, record) {
        const selectedItem = selectList.find(item => item.realValue === val)
        if (selectedItem) {
          record.supplierName = selectedItem.bringOutDataOne
        }
      }
    }
  }
  </script>
  <style scoped lang="less">
  .display-flex {
    display: flex
  }
  .flex1 {
    flex: 1
  }
  </style>
